import React, { useMemo } from "react";
import { useState } from "react";
import { humanReadableDateTime } from "../../../../../app/utils";
import { BackButton } from "../../../../../components/RegularComponents";
import {
  ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY,
  INTERNAL_NOTES_TAB
} from "../../InformationDetailPanel";
import { InternalNotesTable } from "../InternalNotes/InternalNotesTable";

export const InternalNotes = (props) => {
    const { appData, internalNoteCategory /*, applicationType, applicationMode */ } = props;

    const internalNotes = useMemo(() => {
      if (!appData.internalNoteList) {
        return [];
      }

      /* notes of category ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY are not getting shown as internal note.
      administrative_penalties are getting shown in a different tab, 
      however storing object is internalNoteList same as intenal note.
      Adding is hidden by filtering based on hiddenForInternalNoteTab in add internal note section
      */
      if (internalNoteCategory === INTERNAL_NOTES_TAB) {
        return appData.internalNoteList?.filter(
          (note) => note.internalNoteCategory !== ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY
        );
      }
      return appData.internalNoteList.filter(
        (internalNote) =>
          internalNote.internalNoteCategory === internalNoteCategory ||
          internalNote.internalNoteCategory !== ADMINISTRATIVE_PENALTIES_NOTE_CATEGORY
      );
    }, [appData.internalNoteList, internalNoteCategory]);

    const [activeInternalNote, setActiveInternalNote] = useState();

    if (internalNoteCategory === INTERNAL_NOTES_TAB) {
        return (activeInternalNote
            ? <InternalNoteDetailWrapper internalNote={activeInternalNote} setInternalNote={setActiveInternalNote} />
            : <InternalNotesTable internalNotes={internalNotes} setInternalNote={setActiveInternalNote} {...props} />
        )
    }

    return (
        <div>
            <h3>Previous notes</h3>
            {internalNotes.map((internalNote, index) => (
                <InternalNoteDetail internalNote={internalNote} key={index} />
            ))}
        </div>
    )
}

const InternalNoteDetailWrapper = (props) => {
    const {setInternalNote} = props
    const handleGoBack = () => {
        setInternalNote()
    }
    return (
        <div className="licence-application-details-panel">
            <BackButton onClick={handleGoBack} />
            <InternalNoteDetail {...props} />
        </div>
    )
}

const InternalNoteDetail = (props) => {
    const { internalNote } = props;

    return (
        <div style={{ background: "#eee", padding: "1rem", marginBottom: "1rem" }}>
            <div className="row">
                <div className="col-xs-12">
                    <h3>On {humanReadableDateTime(internalNote.createdDate)}, {internalNote.createdBy} wrote:</h3>
                </div>
            </div>
            <div className="row" style={{ marginTop: "0.5rem" }}>
                
                <div className="col-xs-12">
                    <h4><b>Subject</b></h4>
                    <p>{internalNote.internalNoteCategory === "InformationMap" ? "Review Notes" : internalNote.internalNoteCategory}</p>
                </div>
            </div>

            <div className="row" style={{ marginTop: "0.5rem" }}>
                
                <div className="col-xs-12">
                    <h4><b>Note</b></h4>
                    <p>{internalNote.note}</p>
                </div>
            </div>

        </div>
    )
}